import { Injectable } from '@angular/core';
import { CreatorStateService } from '../services/app-services';
import { GuidWrapper } from '../types';
import { ISeat } from '../interfaces';
import { StaticDependenciesService } from '@cinetixx/cinetixx-ui';

@Injectable()
export class ConnectionsManager {

  public static connectionSvg: SVGSVGElement;

  public static clearAllConnections(): void {
    this.initConnections();
  }

  public static deleteConnectionLine(id1: number, id2: number): void {
    const line = this.findLine(id1, id2);

    if (line) {
      line.remove();
    }
  }

  public static initConnections(seats?: GuidWrapper<ISeat>[], container?: HTMLElement): void {
    seats = seats ?? CreatorStateService.seatsPlan.seats;

    this.removeConnectionSvg();

    this.connectionSvg = StaticDependenciesService.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    this.connectionSvg.classList.add('connections', 'pointer-events-none', 'position-absolute', 'full-width', 'full-height');

    while (this.connectionSvg.firstChild) {
      this.connectionSvg.removeChild(this.connectionSvg.firstChild);
    }

    this.drawConnections(seats);

    (container ?? CreatorStateService.roomRef.nativeElement).appendChild(this.connectionSvg);
  }

  public static drawConnections(seats: GuidWrapper<ISeat>[]): void {
    for (let i = 0; i < seats.length; i++) {
      const seat = seats[i];

      if (seat.rightSeatDefinitionId) {
        if (!this.findLine(seat.id, seat.rightSeatDefinitionId)) {
          const rightSeat = seats.find(s => s.id === seat.rightSeatDefinitionId);

          if (rightSeat) {
            this.drawLine(seat, rightSeat);
          }
        }
      }

      if (seat.leftSeatDefinitionId) {
        if (!this.findLine(seat.id, seat.leftSeatDefinitionId)) {
          const leftSeat = seats.find(s => s.id === seat.leftSeatDefinitionId);

          if (leftSeat) {
            this.drawLine(seat, leftSeat);
          }
        }
      }
    }
  }

  public static findLine(id1: number, id2: number): SVGLineElement {
    const lines = Array.from(this.connectionSvg.children) as SVGLineElement[];
    const ids1 = `${id1}, ${id2}`;
    const ids2 = `${id2}, ${id1}`;

    return lines.find(line => {
      const dataIds = line.getAttribute('data-ids');
      return (dataIds === ids1 || dataIds === ids2) ? line : null;
    });
  }

  public static drawLine(fromSeat: GuidWrapper<ISeat>, toSeat: GuidWrapper<ISeat>): void {
    const line = StaticDependenciesService.document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', (fromSeat.sectorElement.webX + (fromSeat.sectorElement.w / 2)).toString());
    line.setAttribute('y1', (fromSeat.sectorElement.webY + (fromSeat.sectorElement.h / 2)).toString());
    line.setAttribute('x2', (toSeat.sectorElement.webX + (toSeat.sectorElement.w / 2)).toString());
    line.setAttribute('y2', (toSeat.sectorElement.webY + (toSeat.sectorElement.h / 2)).toString());
    line.setAttribute('data-ids', [fromSeat.id.toString(), toSeat.id.toString()].join(', '));
    line.setAttribute('stroke', fromSeat.priceAreaColor ?? fromSeat.sectorElement.color ?? 'black');
    line.setAttribute('stroke-width', '3');

    this.connectionSvg.appendChild(line);
  }

  private static removeConnectionSvg(): void {
    if (this.connectionSvg) {
      this.connectionSvg.remove();
      this.connectionSvg = null;
    }
  }
}
